import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ToolTipContainer = styled.div`
  margin-left: ${spacing(2.5)};
`;
